import 'pollen-css';
import 'typeface-inter';
import { base } from './base';
import { variables } from './variables';

export default [variables, base];
